<template>
	<span>
		<v-tooltip top>
			<template v-slot:activator="{ on }">
				<v-btn icon v-on="on" @click="open()"><v-icon>mdi-calendar-refresh</v-icon></v-btn>
			</template>
			<span>Ricrea scadenze</span>
		</v-tooltip>

		<v-dialog v-model="dialog" max-width="900" persistent scrollable>
			<v-card class="background-2 round-card" v-if="dialog">
				<v-card-title class="pa-3">
					<p class="pl-2 mb-0">Ricrea scadenze</p>
					<v-spacer></v-spacer>
					<v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pt-4">
					<!-- documento importato da un XML con scadenze: si puo' ripristinarle -->
					<v-radio-group v-if="preview.xml_available" v-model="source" row class="mt-0" hide-details @change="loadPreview()">
						<v-radio label="Dalla condizione di pagamento" value="payment_term"></v-radio>
						<v-radio label="Dalle scadenze dell'XML ricevuto" value="xml"></v-radio>
					</v-radio-group>
					<p v-if="preview.xml_available && source === 'xml'" class="caption grey--text mt-2 mb-3">
						Le rate tornano quelle del documento ricevuto; risultano modificate a mano se la condizione di pagamento del documento non le riproduce.
					</p>
					<v-progress-linear v-if="loading" indeterminate></v-progress-linear>
					<v-alert v-else-if="!preview.available" type="info" text>{{ preview.reason }}</v-alert>
					<template v-else>
						<v-row>
							<v-col cols="12" md="6">
								<strong>Rate attuali</strong>
								<v-simple-table dense class="background-2">
									<tbody>
										<tr v-for="d in preview.current" :key="'c' + d.id">
											<td>{{ d.installment }}</td>
											<td>{{ d.expiration_date | date }}</td>
											<td class="text-right">{{ d.amount | currency(2) }}</td>
											<td class="text-right grey--text">pag. {{ d.paid | currency(2) }}</td>
											<td><v-icon v-if="d.manual" small color="warning">mdi-pencil</v-icon></td>
										</tr>
									</tbody>
								</v-simple-table>
							</v-col>
							<v-col cols="12" md="6">
								<strong>{{ source === 'xml' ? 'Rate dall\'XML ricevuto' : 'Rate dalla condizione di pagamento' }}</strong>
								<v-simple-table dense class="background-2">
									<tbody>
										<tr v-for="(d, i) in preview.next" :key="'n' + i">
											<td>{{ d.installment }}</td>
											<td>{{ d.expiration_date | date }}</td>
											<td class="text-right">{{ d.amount | currency(2) }}</td>
											<td>{{ d.payment_method }}</td>
										</tr>
									</tbody>
								</v-simple-table>
							</v-col>
						</v-row>
						<v-alert v-if="preview.detached.length" type="warning" text class="mt-3">
							{{ preview.detached.length }} pagamenti verranno sganciati e il loro importo tornerà disponibile come residuo da riallocare:
							<ul class="mt-2">
								<li v-for="(p, i) in preview.detached" :key="i">Pagamento del {{ p.date | date }}: {{ p.amount | currency(2) }}</li>
							</ul>
						</v-alert>
						<v-alert v-else type="success" text class="mt-3">Nessun pagamento verrà sganciato.</v-alert>
					</template>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="info" @click="dialog = false">Annulla</v-btn>
					<v-btn text color="primary" :disabled="loading || !preview.available" :loading="sending" @click="regenerate()">Ricrea</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</span>
</template>

<script>
	export default {
		name: 'regenerate-deadlines-dialog',
		props: {
			documentType: { type: String, required: true },
			documentId: { type: Number, required: true },
		},
		data() {
			return {
				dialog: false,
				loading: false,
				sending: false,
				source: 'payment_term',
				preview: { available: false, reason: '', current: [], next: [], detached: [], xml_available: false },
			}
		},
		methods: {
			open() {
				this.dialog = true
				this.source = 'payment_term'
				this.loadPreview()
			},
			loadPreview() {
				this.loading = true
				this.axios.post('regenerate-deadlines-data', { document_type: this.documentType, id: this.documentId, source: this.source }).then(response => {
					this.preview = Object.assign({ current: [], next: [], detached: [], xml_available: false }, response.data)
					this.loading = false
				}, () => {
					this.loading = false
					this.dialog = false
				})
			},
			regenerate() {
				this.sending = true
				this.axios.post('regenerate-deadlines', { document_type: this.documentType, id: this.documentId, source: this.source }).then(response => {
					this.sending = false
					this.dialog = false
					this.$store.commit('setSnackbar', { timeout: 8000, text: response.data.message, value: true, color: 'success' })
					this.$emit('regenerated', response.data.report)
				}, () => {
					this.sending = false
				})
			},
		},
	}
</script>
